export function TabelaFichaRoc({ cabecalhos, linhas }) {
    return (
        <table className="table table-bordered table-sm" style={{ fontSize: 14 }}>
            <thead>
                <tr>{cabecalhos.map((c) => <th key={c} style={{ color: "#666" }}>{c}</th>)}</tr>
            </thead>
            <tbody>
                {linhas.length === 0
                    ? <tr><td colSpan={cabecalhos.length} style={{ color: "#ccc" }}>Nenhum registro</td></tr>
                    : linhas.map((linha, index) => (
                        <tr key={index} >{linha.map((valor, i) => <td key={i} style={{ color: "#a09d9d" }}>{valor}</td>)}</tr>
                    ))}
            </tbody>
        </table>
    );
}